import { apiClient } from '../apiClient';
import type { ApiResponse } from '../http/types';
import type {
  CategorySummary,
  CreateCategoryRequest,
  UpdateCategoryRequest,
  SiteCategoryApiItem,
} from './category.types';

const base = '/api/SiteManagement';

function normalizeCategory(raw: SiteCategoryApiItem, index: number): CategorySummary {
  return {
    id: raw.id,
    name: raw.name,
    description: raw.description,
    isActive: raw.isActive,
    associatedSiteCount: raw.associatedSiteCount,
    associatedSites: raw.associatedSites,
  };
}

export async function listCategories(): Promise<ApiResponse<CategorySummary[]>> {
  const res = await apiClient.get<SiteCategoryApiItem[]>(`${base}/site-categories`);
  if (!res?.success || !res.data) {
    return res as ApiResponse<CategorySummary[]>;
  }

  return {
    success: true,
    data: res.data.map((item, index) => normalizeCategory(item, index)),
  };
}

export async function createCategory(payload: CreateCategoryRequest): Promise<ApiResponse<CategorySummary>> {
  const res = await apiClient.post<SiteCategoryApiItem>(`${base}/site-categories`, payload);
  if (!res?.success || !res.data) {
    return res as ApiResponse<CategorySummary>;
  }

  return { success: true, data: normalizeCategory(res.data, 0) };
}

export async function getCategory(id: number): Promise<ApiResponse<CategorySummary>> {
  const res = await apiClient.get<SiteCategoryApiItem>(`${base}/site-categories/${id}`);
  if (!res?.success || !res.data) {
    return res as ApiResponse<CategorySummary>;
  }

  return { success: true, data: normalizeCategory(res.data, 0) };
}

export async function updateCategory(id: number, payload: UpdateCategoryRequest): Promise<ApiResponse<CategorySummary>> {
  const res = await apiClient.put<SiteCategoryApiItem>(`${base}/site-categories/${id}`, payload);
  if (!res?.success || !res.data) {
    return res as ApiResponse<CategorySummary>;
  }

  return { success: true, data: normalizeCategory(res.data, 0) };
}

export function deleteCategory(id: number): Promise<ApiResponse<void>> {
  return apiClient.delete<void>(`${base}/site-categories/${id}`);
}
